<template>
  <div :class="{ collapsible, collapsed }" class="app-feature-cell__container">
    <div class="app-feature-cell__header-wrapper">
      <div class="app-feature-cell__title" @click="$_collapsed = !$_collapsed">
        {{ title }}
      </div>
      <app-feature-icon
        :src="icon"
        class="app-feature-cell__icon"
        color="#ff8511"
      />
    </div>
    <div class="app-feature-cell__description">{{ description }}</div>
  </div>
</template>

<script>
/**
 * write a component's description
 */
import AppFeatureIcon from './AppFeatureIcon'

export default {
  name: 'AppFeatureCell',
  components: {
    AppFeatureIcon
  },
  props: {
    title: {
      type: String,
      default: 'Feature Title'
    },
    description: {
      type: String,
      default: 'The three sentence description goes here.'
    },
    icon: {
      type: String,
      default: undefined
    },
    collapsible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      $_collapsed: false
    }
  },
  computed: {
    collapsed () {
      if (!this.collapsible) {
        return false
      }
      return this.$_collapsed
    }
  }
}
</script>

<style scoped>
.app-feature-cell__container {
  display: flex;
  flex-direction: column;
  align-content: stretch;
  width: 42rem; /* Roughly the readable width on iPad. */
  padding-bottom: 2.875rem;
  margin-bottom: 2.875rem;
  border-bottom: 1px solid #ff8511;
}

.app-feature-cell__header-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  margin: 0;
  height: 2.06rem;
}

.app-feature-cell__icon {
  height: 3.25rem;
  width: 3.25rem;
}

.app-feature-cell__title {
  font-family: "Avenir-Heavy", "Helvetica", "sans-serif";
  font-weight: bold;
  font-size: 1.5rem;
  /* color: #ff8511; */
  color: #332924;
  letter-spacing: 0;
  text-align: left;
}

.app-feature-cell__description {
  margin-top: 0.625rem;
  font-family: "Avenir-Medium", "Helvetica", "sans-serif";
  font-size: 1.125rem;
  color: #000;
  letter-spacing: 0;
  text-align: left;
  margin-right: 3.25rem;
  line-height: 1.75rem;
}
</style>
